import { render } from "./Team4Flags.vue?vue&type=template&id=3c9ced64"
import script from "./Team4Flags.vue?vue&type=script&lang=js"
export * from "./Team4Flags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__